import React from "react"
import { Box, LinearProgress, LinearProgressProps, styled } from "@mui/material"

import { colors } from "theme"

type Props = React.HTMLAttributes<HTMLDivElement> &
  LinearProgressProps & {
    paid?: number
    overdue?: number
    nextPayment?: number
  }

const BarPaid = styled((props: LinearProgressProps) => (
  <LinearProgress variant="determinate" color="primary" {...props} />
))(() => ({
  backgroundColor: "transparent",
  color: colors.persianGreen,
  height: "10px",
  position: "absolute",
  top: 0,
  width: "100%",
  zIndex: 15,
}))

const BarOverdue = styled((props: LinearProgressProps) => (
  <LinearProgress variant="determinate" color="error" {...props} />
))(() => ({
  backgroundColor: "transparent",
  color: colors.ruby,
  height: "10px",
  position: "absolute",
  top: 0,
  width: "100%",
  zIndex: 10,
}))

const BarNextPayment = styled((props: LinearProgressProps) => (
  <LinearProgress variant="determinate" color="info" {...props} />
))(() => ({
  backgroundColor: "transparent",
  color: colors.brilliantAzure,
  height: "10px",
  position: "absolute",
  top: 0,
  width: "100%",
  zIndex: 5,
  ".MuiLinearProgress-barColorInfo": {
    background:
      "repeating-linear-gradient(135deg, rgba(0, 169, 149, 0.2), rgba(0, 169, 149, 0.2) 4px, #00a995 4px, #00a995 6px)",
  },
}))

const BarComponent = ({ paid, overdue, nextPayment }: Props) => {
  return (
    <Box sx={{ position: "absolute", height: "100%", width: "100%" }}>
      <BarPaid value={paid} />
      <BarOverdue value={overdue} />
      <BarNextPayment value={nextPayment} />
    </Box>
  )
}

export default BarComponent
